export default __webpack_public_path__ + "static/media/close.d7fc2aa5.svg";